import { mapState } from '/builds/gitlab/gitlab-ee/node_modules/pinia/dist/pinia.mjs?vue3';
import { renderMarkdown } from '~/notes/utils';
import { useNotes } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/notes/store/legacy_notes/index.js?vue3';
import { gfm } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/directives/gfm.js?vue3';
import NoteHeader from '/builds/gitlab/gitlab-ee/app/assets/javascripts/rapid_diffs/app/discussions/note_header.vue?vue3';
import TimelineEntryItem from './timeline_entry_item.vue';
export default {
    name: 'PlaceholderNote',
    components: {
        NoteHeader,
        TimelineEntryItem
    },
    directives: {
        gfm
    },
    props: {
        note: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapState(useNotes, [
            'getUserData'
        ]),
        renderedNote () {
            return renderMarkdown(this.note.body);
        }
    }
};
